<ion-header mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-title>Audit Log Filters</ion-title>
    <ion-buttons slot="start">
      <ion-button mode="ios" fill="clear" (click)="dismiss()" tappable>
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list lines="none" mode="ios">
    <h6 class="ion-text-left ion-padding-start">Date Range</h6>
    <ion-radio-group mode="md" [(ngModel)]="dateRange">
      <ion-item mode="ios" (click)="dateRange = '1d'">
        <ion-label>Last 24 hours</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="1d" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="dateRange = '7d'">
        <ion-label>Last 7 days</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="7d" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="dateRange = '30d'">
        <ion-label>Last 30 days</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="30d" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="dateRange = 'all'">
        <ion-label>All time</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="all" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>

    <h6 class="ion-text-left ion-padding-start">Action Type</h6>
    <ion-radio-group mode="md" [(ngModel)]="actionType">
      <ion-item mode="ios" (click)="actionType = 'all'">
        <ion-label>All types</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="all" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'login'">
        <ion-label>Login</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="login" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'logout'">
        <ion-label>Logout</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="logout" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'create'">
        <ion-label>Create</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="create" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'read'">
        <ion-label>Read/View</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="read" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'update'">
        <ion-label>Update</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="update" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'delete'">
        <ion-label>Delete</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="delete" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'permission_change'">
        <ion-label>Permission Change</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="permission_change" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'financial'">
        <ion-label>Financial</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="financial" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'moderation'">
        <ion-label>Moderation</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="moderation" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'security'">
        <ion-label>Security</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="security" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'export'">
        <ion-label>Export</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="export" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="actionType = 'system'">
        <ion-label>System</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="system" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>

    <h6 class="ion-text-left ion-padding-start">Result</h6>
    <ion-radio-group mode="md" [(ngModel)]="result">
      <ion-item mode="ios" (click)="result = 'all'">
        <ion-label>All results</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="all" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="result = 'success'">
        <ion-label>Success</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="success" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="result = 'failure'">
        <ion-label>Failure</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="failure" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="result = 'pending'">
        <ion-label>Pending</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="pending" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>

    <h6 class="ion-text-left ion-padding-start">Source</h6>
    <ion-radio-group mode="md" [(ngModel)]="source">
      <ion-item mode="ios" (click)="source = 'all'">
        <ion-label>All sources</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="all" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="source = 'legacy'">
        <ion-label>Legacy Audit</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="legacy" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="source = 'subscriptions'">
        <ion-label>Subscription Audit</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="subscriptions" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="source = 'admin_ops'">
        <ion-label>Admin Ops</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="admin_ops" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="source = 'security_events'">
        <ion-label>Security Events</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="security_events" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="source = 'support_operations'">
        <ion-label>Support Operations</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="support_operations" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>

<ion-footer mode="ios">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
      <ion-col sizeXl="7" sizeLg="7" sizeMd="10" sizeSm="12" sizeXs="12">
        <ion-row>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="applyFilters()">Apply</ion-button>
          </ion-col>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="clearFilters()">Clear</ion-button>
          </ion-col>
        </ion-row>
        <br />
      </ion-col>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
